import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { ProductCategoriesState } from "../../models/mp-admin/product-categories-state";

const initialState: ProductCategoriesState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(AdminProductsActions.productCategories.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(AdminProductsActions.productCategories.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		...action.state,
		loading: false
	})),
	on(AdminProductsActions.productCategories.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(AdminProductsActions.productCategories.invalidate, () => initialState)
);

export function productCategoriesReducer(
	state: ProductCategoriesState | undefined,
	action: Action
): ProductCategoriesState {
	return reducer(state, action);
}
